function handleCollectionTagFilter() {
    jQuery('.sm--collection-filter').on('change', function () {
        var $el = jQuery(this).children("option:selected");
        window.location.href = $el.data('url');
    });
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function bindCartWaveSignature() {

  var $checkbox = jQuery('#WaveSignature');
  // var $giveaway_checkbox = jQuery('#Giveaway');
  var $order_note = jQuery('#CartNoteDrawer, #CartNote');
  var customerData = window.customerData;

  $order_note.parent().addClass('hide');

  // Initialize checkbox state and cart note on page load
  function initializeWaveSignature() {
    // Check if customer has Waive_Signature tag (from data attribute or customerData)
    var hasTag = false;
    if (window.customerTags && window.customerTags.indexOf('Waive_Signature') !== -1) {
      hasTag = true;
    }
    
    // Check cookie/localStorage
    var cookieValue = getCookie('wave_signature');
    var storageValue = localStorage.getItem('wave_signature');
    var shouldBeChecked = hasTag || cookieValue === 'yes' || storageValue === 'yes';
    
    // Check if cart note already contains the wave signature text
    var currentNote = $order_note.val() || $order_note.text() || '';
    var noteContainsWave = currentNote.indexOf('wave the delivery signature') !== -1 || 
                          currentNote.indexOf('waive the delivery signature') !== -1;
    
    if (shouldBeChecked || noteContainsWave) {
      // Check the checkbox
      $checkbox.prop('checked', true);
      
      // Set the cart note if it's not already set
      if (!noteContainsWave) {
        var noteText = 'I want to wave the delivery signature of my order.';
        if ($order_note.is('textarea')) {
          $order_note.val(noteText);
        } else {
          $order_note.text(noteText);
        }
        
        // Show the note field if it was hidden
        $order_note.parent().removeClass('hide');
        
        // Update cart via API
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: noteText })
        })
        .then(response => response.json())
        .then(data => console.log('Cart note initialized:', data))
        .catch(error => console.error('Error setting cart note:', error));
      }
    }
  }
  
  // Run initialization
  initializeWaveSignature();

  $checkbox.on('change', function () {

    // Get the giveaway checkbox
    // var addition = '';
    // if($giveaway_checkbox.is(":checked")) {
    //     addition = '<br>I want to enroll in the giveaway.';
    // }
    //
    // if(this.checked) {
    //     $order_note.text('I want to wave the delivery signature of my order.' + addition);
    // } else {
    //     $order_note.text(addition);
    // }

    if (this.checked) {
        // Set a cookie
        setCookie('wave_signature', 'yes', 365);
        localStorage.setItem('wave_signature', 'yes');
        
        // Update cart note in UI
        var noteText = 'I want to wave the delivery signature of my order.';
        if ($order_note.is('textarea')) {
          $order_note.val(noteText);
        } else {
          $order_note.text(noteText);
        }
        
        // Show the note field if it was hidden
        $order_note.parent().removeClass('hide');
        
        // Update cart via API
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: noteText })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart note updated:', data);
        })
        .catch(error => {
          console.error('Error updating cart note:', error);
        });
        
        // Call API to add tag
        if (customerData && customerData.id) {
          fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({customer: customerData}),
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('API call failed');
            }
            return response.json();
          })
          .then(data => {
            console.log('Tag updated:', data);
          })
          .catch(error => {
            console.error('Error updating customer tag:', error);
          });
        } else {
          console.warn('Customer data not available for tag update');
        }
    } else {
      setCookie('wave_signature', 'no', 365);
      localStorage.setItem('wave_signature', 'no');
      
      // Clear cart note in UI
      if ($order_note.is('textarea')) {
        $order_note.val('');
      } else {
        $order_note.text('');
      }
      
      // Update cart via API
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: '' })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart note cleared:', data);
      })
      .catch(error => {
        console.error('Error clearing cart note:', error);
      });
      
      // Call API to remove tag
      if (customerData && customerData.id) {
        fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({customer: customerData}),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('API call failed');
          }
          return response.json();
        })
        .then(data => {
          console.log('Tag removed:', data);
        })
        .catch(error => {
          console.error('Error removing customer tag:', error);
        });
      }
    }

  });

}

// Invoking all functions and methods
jQuery(function () {
    
    // Bind collection tag filter
    handleCollectionTagFilter();

    
    // add 4-in-1 Online Certification Program product
    $('.sm--add-course-button-4-in-1').on('click', function (e) {
        console.log('click');

        e.preventDefault();
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: 44975724691702, // Must be the VARIANT ID
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Added to cart:', data);
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
        });
    });

    jQuery(window).on('load', function () {
      bindCartWaveSignature();
    });

    document.addEventListener('cart:change', function(evt) {
      let cartTotal = parseFloat(evt.detail.subtotal) / 100;
      jQuery('.cart-progress-item').each(function(index, progressItem) {
        let threshold = parseFloat(jQuery(progressItem).data('threshold'));
        if(cartTotal >= threshold) jQuery(progressItem).addClass('progress-reached');
        else jQuery(progressItem).removeClass('progress-reached');
      });
    });
});